import { toNumber, normalizeText } from './convertNotionalToBRL.js'

const SPREAD_STATUSES = new Set(['DEAL'])

function calculateSpreadPips(row) {
  const status = normalizeText(row.status)

  if (!SPREAD_STATUSES.has(status)) return null

  const fwd = toNumber(row.fwd)
  const fwdClient = toNumber(row.fwdclient)
  const side = normalizeText(row.side)

  if (!fwd || fwdClient == null) return null

  // Sinal INVERTIDO em relacao a versao de NDF, e isso e medido, nao suposto.
  // No relatorio de spot o `side` e a ponta da MESA, nao a do cliente: nas 1980
  // operacoes fechadas do synthetic.csv a taxa do cliente esta abaixo do custo
  // em 938 de 938 compras (mediana -6 pips) e acima em 1042 de 1042 vendas
  // (mediana +7). Ou seja, a mesa ganha nos dois lados. Com a formula do NDF o
  // KPI dava -6,78 pips - a mesa perdendo em toda operacao, o que nao acontece.
  if (side === 'SELL' || side === 'VENDA') {
    return (fwdClient - fwd) * 10000
  }

  if (side === 'BUY' || side === 'COMPRA') {
    return (fwd - fwdClient) * 10000
  }

  return null
}

// Simple arithmetic average of side-aware pip spread across DEAL rows -
// every valid row carries equal weight, regardless of notional size.
export function calculateAverageSpreadPips(rows) {
  let sum = 0
  let count = 0

  for (const row of rows) {
    const spreadPips = calculateSpreadPips(row)

    if (spreadPips == null) continue

    sum += spreadPips
    count += 1
  }

  return count > 0
    ? sum / count
    : 0
}
